@if (viewGroupItems) {
	<div class="h-100 scrollbox-autohover">
		<div #thumbnails class="d-flex flex-row mt-2 mb-3 gap-3 scrollbox-content-autohover align-items-center">
			@for (viewGroupItem of viewGroupItems; track viewGroupItem; let isFirst = $first) {
				<a
					[routerLink]="[getRouterLink(viewGroupItem)]"
					[attr.aria-description]="'attachmentLink with id ' + viewGroupItem.id"
					queryParamsHandling="merge"
					[id]="'attachment-item-link-' + viewGroupItem.id"
					class="thumbnail-wrapper d-flex align-items-center justify-content-center p-1 cursor-pointer img-wrapper"
					[ngClass]="{ 'border-primary border-2': selectedItem && viewGroupItem.id === selectedItem.id }">
					<div>
						<img
							[src]="viewGroupItem.thumbnailUrl"
							width="70"
							height="70"
							loading="lazy"
							decoding="async"
							style="object-fit: scale-down"
							[alt]="viewGroupItem.title"
							onerror="this.src='assets/material/help-24px.svg'"
							class="thumbnail" />
					</div>
				</a>
			}
		</div>
	</div>
}
